module.exports = __webpack_public_path__ + "img/maceio01.34ac2a27.jpg";